import { render, staticRenderFns } from "./ModalTermosServico.vue?vue&type=template&id=58d78f4b&scoped=true&"
import script from "./ModalTermosServico.vue?vue&type=script&lang=js&"
export * from "./ModalTermosServico.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermosServico.vue?vue&type=style&index=0&id=58d78f4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d78f4b",
  null
  
)

export default component.exports